import { Link } from "react-router-dom";
import { pricingContent } from "../content/pricing.js";

export default function PricingPage() {
  const { offerings, priceDrivers, retainer, trust, intro } = pricingContent;

  return (
    <article className="site-page">
      <div className="site-page__inner site-page__inner--wide">
        <p className="site-page__eyebrow">Pricing</p>
        <h1 className="site-page__title">
          Commercial ranges &amp; what moves the needle
        </h1>
        <p className="site-page__lead">{intro}</p>

        <div className="pricing-grid">
          {offerings.map((o) => (
            <section key={o.id} className="pricing-card">
              <h2>{o.title}</h2>
              <p className="pricing-card__range">{o.range}</p>
              <p className="pricing-card__summary">{o.summary}</p>
              <div>
                <p className="pricing-card__subhead">Typically includes</p>
                <ul className="site-page__list pricing-card__list">
                  {o.includes.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <p className="pricing-card__muted">{o.notIncluded}</p>
            </section>
          ))}
        </div>

        <section className="site-section">
          <h2>What adjusts the budget</h2>
          <ul className="site-page__list pricing-drivers-list">
            {priceDrivers.map((d) => (
              <li key={d}>{d}</li>
            ))}
          </ul>
        </section>

        <section className="site-section">
          <h2>{retainer.headline}</h2>
          <p className="site-page__lead">{retainer.body}</p>
          <div className="pricing-retainer-cards">
            {retainer.examples.map((ex) => (
              <div key={ex.label} className="pricing-retainer-card">
                <h3>{ex.label}</h3>
                <p className="pricing-card__range">{ex.price}</p>
                <p>{ex.scope}</p>
              </div>
            ))}
          </div>
          <p className="pricing-card__muted">{retainer.note}</p>
        </section>

        <aside className="trust-block trust-block--contracts">
          <h2>{trust.title}</h2>
          <p>{trust.body}</p>
          <p className="trust-block__disclaimer-snippet">{trust.disclaimerSnippet}</p>
          <p className="site-page__muted">
            <Link to="/contracts">{trust.linkLabel} →</Link>
          </p>
        </aside>

        <p className="site-page__cta">
          <Link to="/contact" className="site-button-primary">
            Book a scoped conversation
          </Link>
          <Link to="/" className="site-button-ghost">
            ← Back to home
          </Link>
        </p>
      </div>
    </article>
  );
}
